<template>
<v-app id="inspire">

    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
  <v-container fluid fill-height align-start>
    <v-row  >
      <v-col md="12" lg="12" cols="12">
        <h1 class="text-h3 text-center"  style="color: #FFFFFF;font-family: 'Poppins', sans-serif !important;">Tipos de Lista {{negocio.negocio}}</h1>
        <br/>
        <v-alert
        :value="alertborrador"
        color="red"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Tipo Lista se borro con éxito.
       </v-alert>
       <v-alert
        :value="alertnuevo"
        color="primary"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Tipo Lista se agrego con éxito.
       </v-alert>
       <v-alert
        :value="alerteditar"
        color="green"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Tipo Lista se edito con éxito.
       </v-alert>
        <v-data-table
      :headers="headers"
      :items="TipoListas"
      sort-by="TipoLista"
      sort-desc
      class="elevation-1"
      :search="search"
      :loading="progr"
      no-data-text="No hay datos disponibles para mostrar."
      no-results-text="No hay resultados para la búsqueda."
      loading-text="Cargando... Por favor espere."
      style="background-color: #393E46;"
    >
      <template v-slot:top>
        <v-toolbar flat >
          <v-toolbar-title class="hidden-sm-only hidden-xs-only">Tipos de Lista</v-toolbar-title>
          <v-btn @click="dameTipoListas"><v-icon>fas fa-sync-alt</v-icon></v-btn>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo Tipo de Lista</v-btn>
            </template>
            <v-card  color="#393E46">
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" lg="12" sm="12" md="12">
                      <v-text-field v-model="editedItem.tipoListaNombre" label="Nombre"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-text-field disabled v-model="editedItem.colorQR" label="Color QR" ></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="12" sm="12" md="12">
                      <v-color-picker v-model="editedItem.colorQR" type="hex" hide-inputs  ></v-color-picker>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogdelete" persistent max-width="350">
        <v-card  color="#393E46">
          <v-card-title class="headline">Desea eliminar esta TipoLista?</v-card-title>
          <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="close">No</v-btn>
            <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon
          small
          color="blue"
          class="mr-2"
          @click="editItem(item)"
        >
          fas fa-edit
        </v-icon>
      </template>
          <template v-slot:[`item.dactiva`]="{ item }">
            <v-switch v-model="item.activa" @click="activaItem(item)" ></v-switch>
          </template>
          <template v-slot:[`item.dpromotores`]="{ item }">
            <v-switch v-model="item.promotores" @click="activaItem(item)" ></v-switch>
          </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="dameTipoListas">Cargar de Nuevo</v-btn>
      </template>
    </v-data-table>
      </v-col>
    </v-row>
    <leftmenu :abreviado="abreviado" />
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from 'axios';
import md5 from 'js-md5';
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {

  title: 'Tipos de Lista | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerabaja,
    leftmenu,
  },
    data: () => ({
      drawer: null,
      idnegocio: 0,
      abreviado:'NN',
      overlay:false,
      negocio: {},
      dbreads: [
      {
        text: 'negocio',
        disabled: true,
        href: 'breadcrumbs_dashboard',
      },
      {
        text: 'TipoListas',
        disabled: true,
        href: 'breadcrumbs_link_2',
      },
    ],
      progr: true,
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      token:'',
      dialog: false,
      dialogdelete: false,
          date: new Date().toISOString().substr(0, 10),
              menu1: false,

      TipoListas: [],
      search: '',
      editedIndex: -1,
      editedItem: {
        id: null,
        tipoListaNombre: '',
        negocio: {},
        promotores: true,
        activa: true,
        colorQR:'#fffffff'
    },
    defaultItem: {
      id: null,
      tipoListaNombre: '',
      negocio: {},
      promotores: true,
      activa: true,
      colorQR:'#fffffff'

    },
headers: [
                { text: 'Acciones', value: 'action', sortable: false },
        { text: 'TipoLista', align: 'left',  value: 'tipoListaNombre'},
        { text: 'Negocio', value: 'negocio.negocio' },
      { text: 'Activa', value: 'dactiva' },
  { text: 'Promotores', value: 'dpromotores' },
      ]
  }),
  mounted (){
        this.idnegocio =  this.$route.params.idnegocio
        this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.dameTipoListas();
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })
    }else{
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.dameTipoListas();
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
    }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
    "$route.params.idnegocio"(value) {
          console.log(value);
           this.idnegocio =  this.$route.params.idnegocio
           this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
      if (this.usuario.id === undefined){
        this.$router.push({ path: '/' });
      }else {
        this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
        this.dameTipoListas();
        this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
      }

    },
  },
  methods : {
    dameTipoListas(){
      this.progr = true;
        axios
        .get('tipolistas/negocio/' + this.idnegocio,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        } )
        .then(response => {
            this.TipoListas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
        })
        .catch((error)  => {
        console.log(error);
          this.progr = false;
        });
    },
    editItem (item) {
      this.editedIndex = this.TipoListas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.TipoListas.indexOf(item);
      this.dialogdelete = true;
    },

    activaItem (item) {
      this.editedItem = Object.assign({}, item)
      var bodyFormData2 = new FormData();
      bodyFormData2.append("data",JSON.stringify(this.editedItem));

      axios
          .post('tipolistas/editar',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          }).then(response => {
        console.log(response);
        this.editedIndex = this.Temporadas.indexOf(item);
        this.Temporadas = response.data;

      })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
    },
    borralo (){
      let md555 = md5(this.TipoListas[this.editedIndex].TipoListaId.toString());
      axios
      .delete('tipolistas/TipoLista/'+md555,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
      .then(response => {
                console.log(response);
                 this.dialogdelete = false;
        this.alertborrador = true;
        this.TipoListas = response.data;
                })
      .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.TipoListas[this.editedIndex], this.editedItem);
        var bodyFormData2 = new FormData();
        bodyFormData2.append("data",JSON.stringify(this.editedItem));

        axios
      .post('tipolistas/editar',bodyFormData2,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                console.log(response);
                this.alerteditar = true;
                this.editedItem = this.defaultItem
                this.dameTipoListas();
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      } else {
        var bodyFormData = new FormData();
        this.editedItem.negocio = this.negocio
        bodyFormData.append("data",JSON.stringify(this.editedItem));

        axios
      .post('tipolistas/editar',bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                this.TipoListas = response.data;
                this.alertnuevo = true;
                console.log(response);
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      }
      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Tipo de Lista' : 'Editar Tipo de Lista'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      cliente: "cliente"
    })
  }
};
</script>
